import { IKlarnaData, IKlarnaState } from 'app/components/Klarna/types'
import { KLARNA_EXPRESS_ADD, KLARNA_EXPRESS_REMOVE, KLARNA_EXPRESS_ERROR } from '../constants/ActionTypes'

function addKlarnaExpress(values: IKlarnaData) {
    return {
        type: KLARNA_EXPRESS_ADD,
        payload: values,
    }
}

function removeKlarnaExpress() {
    return {
        type: KLARNA_EXPRESS_REMOVE,
    }
}

function klarnaExpressError(error: string | null) {
    return {
        type: KLARNA_EXPRESS_ERROR,
        payload: error,
    }
}

export default function setKlarnaExpress({ values, error = '' }: IKlarnaState) {
    if (error) return klarnaExpressError(error)
    return values ? addKlarnaExpress(values) : removeKlarnaExpress()
}
